import React from 'react';
import { AlertTriangle, CheckCircle, Clock } from 'lucide-react';

const alerts = [
  {
    id: 1,
    title: 'CMMC 2.0 Requirement Update',
    description: 'New cybersecurity requirements for defense contractors',
    severity: 'high',
    status: 'pending',
    dueDate: '2024-03-31',
  },
  {
    id: 2,
    title: 'ISO 27001 Certification',
    description: 'Annual certification renewal required',
    severity: 'medium',
    status: 'in_progress',
    dueDate: '2024-04-15',
  },
  {
    id: 3,
    title: 'DFARS Compliance Check',
    description: 'Quarterly compliance verification completed',
    severity: 'low',
    status: 'completed',
    dueDate: '2024-03-15',
  },
];

export function ComplianceAlerts() {
  return (
    <div>
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-medium text-gray-900">Compliance Alerts</h2>
        <span className="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800">
          {alerts.filter(a => a.status !== 'completed').length} Active
        </span>
      </div>

      <div className="mt-6 space-y-4">
        {alerts.map((alert) => (
          <div
            key={alert.id}
            className={`rounded-lg border p-4 ${
              alert.severity === 'high'
                ? 'border-red-200 bg-red-50'
                : alert.severity === 'medium'
                ? 'border-yellow-200 bg-yellow-50'
                : 'border-blue-200 bg-blue-50'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                {alert.status === 'completed' ? (
                  <CheckCircle className="h-5 w-5 text-green-500" />
                ) : alert.severity === 'high' ? (
                  <AlertTriangle className="h-5 w-5 text-red-500" />
                ) : (
                  <Clock className="h-5 w-5 text-yellow-500" />
                )}
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-gray-900">{alert.title}</h3>
                  <p className="mt-1 text-sm text-gray-500">{alert.description}</p>
                </div>
              </div>
              <div className="ml-4">
                <span
                  className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${
                    alert.status === 'completed'
                      ? 'bg-green-100 text-green-800'
                      : alert.status === 'in_progress'
                      ? 'bg-yellow-100 text-yellow-800'
                      : 'bg-gray-100 text-gray-800'
                  }`}
                >
                  {alert.status.replace('_', ' ')}
                </span>
              </div>
            </div>
            <div className="mt-2 text-sm text-gray-500">
              Due: {new Date(alert.dueDate).toLocaleDateString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}